/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from 'react';
import downloadImg from './dndimages/download-icon.png';
import Monster from './model/Monster';

interface DownloadVttFormatButtonProps {
  getData: () => Monster;  // Getter function instead of direct data
  filename: string;
}

const DownloadVttFormatButton: React.FC<DownloadVttFormatButtonProps> = ({ getData, filename }) => {

  const handleDownload = () => {
    Monster.exportMonsterToXml(getData()); 
  };

  return (
    <button onClick={handleDownload} id='DownloadMonsterButton' title='Download monster as .mod file, for use as an import source into VTT such as Fantasy Grounds'>
      <img src={downloadImg} alt="Download monster as .mod file" width="16px" /> Export to VTT
    </button>
  );
};

export default DownloadVttFormatButton;
